import api from "./api";

export const inquiriesService = {
  getAll: async (
    page = 1,
    limit = 10,
    search = "",
    sortBy = "createdAt",
    sortOrder = "desc",
  ) => {
    const response = await api.get("/api/admin/inquiries", {
      params: { page, limit, search, sortBy, sortOrder },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/admin/inquiries/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/admin/inquiries/${id}`);
    return response.data;
  },
};
